export function formatHm(decimalHour: number): string {
  const totalMinutes = Math.round(decimalHour * 60);
  return `${String(Math.floor(totalMinutes / 60)).padStart(2, "0")}:${String(totalMinutes % 60).padStart(2, "0")}`;
}
